<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      坪山围站<br>
站点介绍<br>
坪山围站位于坪山区坪山大道与深汕路交叉口处， 车站主体沿坪山大道呈南北走向布置，南接锦龙站，北 接坪山广场站。 坪山围站是14号线与16号线的换乘站，车站色彩以 灰色调为主，以客家“围龙屋”为主题，提取半月池+荷花 的水元素，突显本站客家文化特征。车站为地下三层结 构，地下一层为14、16号线站厅层，地下二层为14号线 站台层，地下三层为16号线站台层，站台形式为岛式站 台。车站设置有6个出入口，临近益田假日世界和坪山公 园，周边为成熟配套生活区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:13	23:11	14号线	4分30秒	6分15秒<br>
沙田	06:43	00:13	14号线	4分30秒	6分15秒<br>
大运	06:25	23:34	16号线	5分32秒	6分48秒<br>
田心	05:59	23:14	16号线	5分32秒	6分48秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:11	23:11	14号线	5分25秒	6分15秒<br>
沙田	06:43	00:13	14号线	5分25秒	6分15秒<br>
大运	06:34	23:34	16号线	5分50秒	6分钟-9分钟<br>
田心	06:05	23:14	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:11	00:11	14号线	5分钟	6分15秒<br>
沙田	06:43	01:13	14号线	5分钟	6分15秒<br>
大运	06:34	00:34	16号线	5分50秒	6分钟-9分钟<br>
田心	06:05	00:14	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
坪山大道东侧（南）、坪山公园、坪山汽车总站<br><br>
B出入口:<br>
坪山大道东侧（北）、坪山街道办事处<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 坪山大道东纵路口（西侧）<br>
366、833、E20、M277、M295、M325、M326、M439、M546、高峰专线8、高峰专线64<br><br>
B出入口:<br>
公交站名： 坪山电子城①<br>
963、978、E22、E34、M136、M361、高峰专线8、深惠3A<br><br>
B出入口:<br>
公交站名： 坪山电子城②<br>
366、833、915、B760、E20、M326、M295、M434、M439、M443、M479、M575、M576、高峰专线64<br><br>
B出入口:<br>
公交站名： 坪山街道办<br>
B760、M575、M576<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>